<template>

    <!-- <q-btn icon="analytics" label="Récap. Mensuelle" dense outline square no-caps size="sm"
            @click="courseStore().recapMonthly()"
            v-if=" ! c_state.recapMonthlyOpenModal && !$_.size(c_state.recapMonthlyResult)"
            :disable="disable" />

    <q-btn icon="analytics" label="Rouvrir la Récap. Mensuelle" dense outline square no-caps size="sm"
            @click="c_state.recapMonthlyOpenModal = !c_state.recapMonthlyOpenModal"
            v-if="$_.size(c_state.recapMonthlyResult)" /> -->


<MyDialog v-if=" ! disable && c_state.recapMonthlyOpenModal" v-model="c_state.recapMonthlyOpenModal"
            :title="size_recapMonthlyResultColis ? 'Récap. sur la période du '+c_state.recapMonthlyResult?.period : 'Récap. sur une période'"
            :subtitle="size_recapMonthlyResultColis ? '<small>'+c_state.recapMonthlyResult?.count_colis+' Colis au total &nbsp; (pas forcément du type demandé...)</small>' : ''"
            @closed="c_state.recapMonthlyOpenModal = false"
            can-maximized
            @is-maximized="v => grid = v">
            <!-- @update:modelValue="v => getDatas(v)"> -->

<!-- FORM -->

    <MyExpansion class="q-mx-xs q-mt-xs q-mb-md" :default-opened=" ! size_recapMonthlyResultColis">

        <template #avatar><q-icon name="search" /></template>
        <template #label>Effectuer une Recherche</template>

        <q-card flat bordered square>

            <q-card-section>

                <div v-if="use_range_dates" class="row q-col-gutter-sm q-mb-sm">

                    <q-input filled square dense input-class="cursor-pointer" hide-bottom-space class="col-12"
                            v-model="dates_selected_str"
                            mask="du ##/##/#### au ##/##/####"
                            clearable @clear="range_dates_selected = {from:null,to:null}"
                            hint="Sélectionnez la date de début puis la date de fin">
                        <template v-slot:append><q-icon name="date_range" class="cursor-pointer" /></template>

                        <q-popup-proxy transition-show="scale" transition-hide="scale" ref="PopupDatePicker">

                            <q-date minimal mask="YYYY-MM-DD" v-model="range_dates_selected"
                                range
                                @update:model-value="v=> {  dates_selected_str = 'du '+reverseDate(v.from,'-','/')+' au '+reverseDate(v.to,'-','/');
                                                            $refs.PopupDatePicker?.hide()
                                                        }">
                                <template #default>
                                    <small class="text-info">Sélectionnez la date de début puis la date de fin</small>
                                </template>
                            </q-date>

                        </q-popup-proxy>
                    </q-input>

                </div>

                <div v-else class="row q-col-gutter-sm q-mb-sm">

                    <q-select v-model="month_selected" label="Mois *" class="col-6"
                                :options="months" emit-value map-options options-dense
                                :disable="loading" />

                    <q-select v-model="year_selected" label="Année *" class="col-6"
                                :options="years" emit-value map-options
                                :disable="loading" />

                </div>


                <p class="q-mb--sm text-right">
                    <q-btn :label="!use_range_dates ? 'Utiliser un intervalle de dates' : 'Sélection Mensuelle'"
                            dense size="sm" flat square no-caps :icon-right="use_range_dates ? 'event' : 'date_range'"
                                @click="use_range_dates = !use_range_dates" />
                                <!-- @click="()=> { use_range_dates = !use_range_dates;  if(!use_range_dates){ range_dates_selected = {from:null,to:null}; dates_selected_str = '' } }" /> -->
                </p>
            </q-card-section>

            <q-card-section class="row q-col-gutter-sm">


                <MySelect v-if="$_.size(expeditors)"
                            v-model="expeditor_selected" label="Expéditeur" class="col-6 q-py-sm"
                            clearable
                            :options="expeditors" emit-value map-options hint="facultatif"
                            :disable="loading" />


                <MySelect v-if="$_.size(recipients)"
                            v-model="recipient_selected" label="Destinataire" class="col-6 q-py-sm"
                            clearable
                            :options="recipients" emit-value map-options hint="facultatif"
                            :disable="loading" />

            </q-card-section>


            <q-card-section class="row q-col-gutter-sm q-mt--md q-mb-md justify-center">

                <!-- <q-select v-model="natures_selected" label="Nature(s) des Colis" class="col-6"
                            multiple use-chips clearable
                            :disable="loading"
                            :options="natures" hint="facultatif" /> emit-value map-options -->

                <q-field v-for="(nature, k) in pp().options_natures" :key="k" borderless :color="$q.dark.isActive ? 'white' : 'black'" filled square dense>
                    <q-checkbox :label="nature" left-label
                                v-model="natures_selected[nature]" />
                                <!-- @update:model-value="v => natures_selected[nature] = v" /> -->
                </q-field>

            </q-card-section>

            <q-separator />
            <q-card-actions align="around">

                <q-btn v-if="size_recapMonthlyResultColis" @click="c_state.recapMonthlyResult = []" icon="delete_outline" color="warning" flat square size="sm">
                    <q-tooltip>Vider la période en cours</q-tooltip>
                </q-btn>

                <q-btn @click="submit()" label="Rechercher" icon="search" dense color="positive" outline square no-caps
                        :loading="loading" />

            </q-card-actions>
        </q-card>
    </MyExpansion>


<!-- RESULTS -->

    <div v-if="size_recapMonthlyResultColis" v-gsinit>

        <MyAlert dense no-bg dismiss auto-close="15">
            <small>Vous pouvez fermer ou même changer de page sans perdre ces données.<!-- <br/><small class="text-warning">Ceci, sans recharger la page du navigateur.</small> --></small>
        </MyAlert>


        <div class="q-px-sm q-mt-xs q-mb-md row q-col-gutter-sm">
            <!-- <div class="col-5">
                <q-btn icon="analytics" label="Nouveau Récapitulatif Mensuel" outline square no-caps size="sm" class="full-width"
                        @click="courseStore().recapMonthly()" />
            </div> -->
            <div class="col-12">
                <!-- <q-btn v-if="$_.size(c_state.recapMonthlyResult?.recap)" :icon="selection ? 'close' : 'check'" :label="(selection ? 'Désa': 'A')+ 'ctiver Sélections'" dense outline square no-caps size="sm" class="full-width"
                        @click="selection = !selection" /> -->

                <q-btn outline square no-caps class="full-width" color="purple"
                        :disable=" ! size_courses_selected"
                        @click="courseStore().exportCoursesXLS()"><!--  v-if="selection" -->
                    <b>Export XLSX</b>&nbsp;
                    ({{ pluralize(size_courses_selected, 'course sélectionnée') }})
                </q-btn>
            </div>
        </div>
        <q-separator v-if="!grid" />


        <q-list dense separator :class="grid ? 'full-width row q-col-gutter-sm q-mt-md' : ''">


            <q-item v-for="(course, k) in c_state.recapMonthlyResult?.recap" :key="k" :class="grid ? 'col-xs-12 col-sm-6' : ''">
            <!-- <q-item v-for="(course, k) in $_.concat(c_state.recapMonthlyResult?.recap, c_state.recapMonthlyResult?.recap, c_state.recapMonthlyResult?.recap)" :key="k" :class="grid ? 'col-xs-12 col-sm-6' : ''"> -->

                <MyExpansion dense :class="'full-width'+ ((k == 0 && grid) ? ' border-top q-pt-xs' : '')">

                    <template #avatar><!--  v-if="selection" -->

                        <q-checkbox v-model="c_state.recapMonthlyResult.selected[course.id]" />
                    </template>

                    <template #label><b>{{ course.ref }}</b>&nbsp;<q-btn icon="content_copy" @click.stop="copyToClipboard(course.ref, 'Référence Colis')" dense square size="xs" class="q-ml-md" /></template>
                    <template #sublabel>
                        <!-- Créée le: {{ formatDate({datetime: course.created_at, withHour: true}) }} -->
                        <b>{{ course.count_colis }} Colis</b><span v-if="!isProd || isMaster"> - ID: {{ course.id }}</span>
                    </template>

                    <div class="q-pb-xl">

                        <q-scroll-area class="fit q-pb-sm"
                                        :thumb-style="app_state().scrollarea_bar_style_right"
                                        :style="'height: '+(grid ? 600 : 400)+'px!important'">

                            <q-list v-if="!expeditor_selected || !recipient_selected" dense>

                                <q-item v-if=" ! expeditor_selected">
                                    <q-item-section avatar class="normal"><b>Expéditeur</b></q-item-section>
                                    <q-item-section><q-item-label>{{ $_.find(expeditors, {value: course.shop_id})?.label }}</q-item-label></q-item-section>
                                </q-item>
                                <q-separator v-if=" ! recipient_selected" />
                                <q-item v-if=" ! recipient_selected">
                                    <q-item-section avatar class="normal"><b>Destinataire</b></q-item-section>
                                    <q-item-section><q-item-label></q-item-label>{{ $_.find(recipients, {value: course.recipient_id})?.label }}</q-item-section>
                                </q-item>
                            </q-list>

                            <ListStatus :item="course" />

                            <q-separator />

                            <ListEvents :item="course" />


                            <q-list class="q-mt-sm q-mb--md col-12">
                                <q-item dense>
                                    <q-item-section>
                                        <q-item-label header>{{ course.count_colis }} Colis :</q-item-label>
                                    </q-item-section>
                                    <q-item-section side>
                                        <CopyAllColisRefs :many-colis="course.colis" size="sm" />
                                    </q-item-section>
                                </q-item>
                            </q-list>
                            <ListDatasColis v-for="(colis, key) in course.colis" :key="key" :colis="colis" /><!--  :omit="['label','ref']" -->
                        </q-scroll-area>
                    </div>
                </MyExpansion>

                <q-separator vertical v-if="grid && ((k % 2) === 0)" />
            </q-item>
        </q-list>
    </div>

    <MyAlert v-if=" ! loading && $_.size(c_state.recapMonthlyResult) && ! size_recapMonthlyResultColis" dense class="q-mx-sm">
        Aucune Course Terminée ou en Stock dans cette période et avec ces paramètres.
    </MyAlert>

</MyDialog>
</template>

<script setup>

import { /* link, open,formatDate,   */pp, app_state, pluralize, copyToClipboard, dateNow, notify, formatDate, reverseDate } from "@helpers";
import { /* onMounted */ watch } from "@vue/runtime-core";
import { ref, computed } from "@vue/reactivity";
import { courseStore } from "@stores";

import ListDatasColis from "@page/Colis/partials/ListDatasColis.vue";
import ListStatus from './ListStatus.vue'
import ListEvents from './ListEvents.vue'


const props = defineProps({
    disable: Boolean,
})

let c_state = courseStore().$state

let grid = ref(false)

let size_recapMonthlyResultColis = computed(()=> c_state.recapMonthlyResult?.count_colis )

let size_courses_selected = computed(()=> _.filter(c_state.recapMonthlyResult.selected, s=>s)?.length )

let loading = ref(false)


let years       = ref([])
let months      = ref([])


// let natures     = ref([])
let expeditors  = ref([])
let recipients  = ref([])


let use_range_dates = ref(true)

let date_now = dateNow('YYYY-MM')
let year     = Number(dateNow('YYYY'))
let month    = Number(dateNow('MM'))

// let range_dates = ref({from: formatDate({sub:{months: 1},format:'YYYY-MM-DD'}), to: formatDate({format:'YYYY-MM-DD'})})

let dates_selected_str = ref('')
let range_dates_selected = ref({from:null,to:null})
                    //     from: (use_range_dates.value ? formatDate({sub:{months: 1},format:'YYYY-MM-DD'}) : null),
                    //     to: (use_range_dates.value ? formatDate({format:'YYYY-MM-DD'}) : null)
                    // })

let year_selected       = ref(year)
let month_selected      = ref(month)
// let natures_selected    = ref([])
let natures_selected    = ref({})
let expeditor_selected  = ref(null)
let recipient_selected  = ref(null)


const submit = async ()=>{

    if( ! use_range_dates.value){

        var month_selected_str = (Number(month_selected.value) < 10 ? '0'+month_selected.value : month_selected.value)
    // log(date_now, year_selected.value+'-'+month_selected_str)

        if(date_now < year_selected.value+'-'+month_selected_str){
            return notify('warning', "Cette date n'est pas valide...", month_selected_str+'/'+year_selected.value)
        }
    } else {
        if( ! range_dates_selected.value?.from || ! range_dates_selected.value?.to){
            return notify('warning', "Aucun intervalle de dates présent...")
        }
    }

    loading.value = isProd// ? true : false


    var natures = []
    _.each(natures_selected.value, (v,k)=>{
        if(v){ natures.push(k) } // donner juste les natures, sans les valeurs "true/false"
    })

    // log('in submit RecapMonthly', use_range_dates.value,range_dates_selected.value, year_selected.value,month_selected_str,natures_selected.value, natures ,expeditor_selected.value,recipient_selected.value)


    await axios.post(route('course-recap-monthly'), {
            range_dates_selected: range_dates_selected.value,
            use_range_dates: use_range_dates.value,

            year: year_selected.value,
            month: month_selected_str,

            natures: natures,//natures_selected.value,

            expeditor_id: expeditor_selected.value,
            recipient_id: recipient_selected.value,
        })
        .then((res)=>{
            // log('in OK recapMonthly submit()', res)

            c_state.recapMonthlyResult = res.data ?? []
        })
        .catch((err)=>{
            // log('in ERROR recapMonthly submit()', err)
            if(err.status == 403){
                return notify('warning', "Vous n'avez pas les droits nécessaires...")
            }
        })

    loading.value = false
}


watch(c_state, v => {
    if(v.recapMonthlyOpenModal){
        getDatas()
    }
})


// onMounted(async ()=>{
const getDatas = async (/* opened */)=>{
// const getDatas = (opened)=>{

// log('OPENED',opened,c_state.recapMonthlyOpenModal)
    // if(c_state.recapMonthlyOpenModal){
    // if(opened){

        if( ! _.size(years.value)){
            years.value = [ {label: year, value: year} ]
            for(var y = (year - 1); y >= (year - 3); y--){
                years.value.unshift( {label: y, value: y})
            }
        }

        if( ! _.size(months.value)){
            // let months = []
            // for(var m = 1; m <= 12; m++){
            //     var m_str = (m < 10 ? '0'+m : m)
            //     // months.push({label: m_str+'/'+year_selected.value, value: Number(m_str)})
            //     months.value.push({label: `${m_str}`, value: m})
            // }
            _.each($q.lang.date.months, (m,k)=>{
                months.value.push({label: m, value: (k+1)})
                // var m_str = ((k+1) < 10 ? '0'+(k+1) : (k+1))
                // months.value.push({label: m, value: m_str})
            })
        }

        if( ! _.size(natures_selected.value)){ // pour les checkbox
            _.each(pp().options_natures, (n,k)=>{
                natures_selected.value[n] = true // cochée par défaut
            })
        }
        // if( ! _.size(natures.value)){ pour le sélecteur...
        //     natures.value = pp().options_natures
        //     // let natures = []
        //     // _.each(pp().options_natures, (n,k)=>{
        //     //     natures.push({value: k, label: n})
        //     // })

        //     // natures.value.unshift('Tout')
        // }


        // if( ! _.size(expeditors.value)){
        if( ! _.size(expeditors.value) || ! _.size(recipients.value)){

            await axios.get(route('get-all-expeditors'))
                .then((res)=>{
                    expeditors.value = res.data.expeditors


                    recipients.value = res.data.expeditors
                })
        }


        // if( ! _.size(recipients.value)){
        //     // let recipients = ref([])//pp().all_users

        //     await axios.get(route('get-all-recipients'))
        //         .then((res)=>{
        //             recipients.value = res.data.recipients
        //         })
        // }

        // log('in RecapMonthly.vue',date_now, year, years.value, month, months.value, natures.value, recipients.value)
    // }
// })
}

</script>
